import { FileResponse } from 'app/shared/file-response';
import { FacetsResponse } from '../facet/facets-response';
import { StoryStatus } from './story-status';
import { UserStatus } from 'app/auth/user-status';
import { UserRole } from 'app/auth/user-role';
import { IDatePicker } from "../../shared/date.const";

export interface IUserAvatar {
  fileName: string;
  url: string;
}

export interface IStoryUser {
  id: number;
  email: string;
  userName: string;
  fullName: string;
  avatar: IUserAvatar;
  status: UserStatus;
  role: UserRole;
}

export interface IStory {
  id?: string;
  title: string;
  content: string;
  start: string;
  end?: string;
  dateComponents: IDatePicker;
  units: StoryUnit[];
  status: StoryStatus;
  images?: FacetsResponse<FileResponse>;
  audio?: {
    data: IAudio[];
    total: number;
  };
  user?: IStoryUser;
  reactions: IReactionsResponse;
}

export interface IAllowGlimpseResponse {
  key: string;
  url: string;
}

export interface IStoryPayload {
  id?: string;
  title: string;
  content: string;
  dateComponents: IDatePicker;
  start: Date | string;
  end?: string;
  units: StoryUnit[];
  status: StoryStatus;
  images?: FacetsResponse<FileResponse>;
  audio?: {
    data: IAudio[];
    total: number;
  } | string;
  acl?: IIclData;
}

export interface IAudio {
  fileName: string;
  sort: number;
  storyId: string;
  url: string;
}

export interface StoryForm {
  id: string;
  title: string;
  content: string;
  dateComponents: IDatePicker;
  start: string;
  units: number[];
  status: StoryStatus;
  imageFile: File;
  audio: File;
}

export interface StoryUnit {
  id: string;
  lenseId: number;
}

export interface IReactionData {
  count: number;
  userHasReacted: boolean;
}

export enum ReactionType {
  Comments = 'comments',
  Heart = 'heart',
}

export type IReactionsResponse = {
  [key in ReactionType]: IReactionData;
};

export type IReactions = {
  [key: string]: IReactionsResponse;
};

export interface ICommentReactions {
  [key: string]: {
    total: number;
    userHasReacted: boolean;
    userReacted: boolean;
  };
}

export interface ICommentResponse {
  total: number;
  data: IComment[];
}

export interface IComment {
  content: string;
  createdAt: string;
  id: string;
  isElevated: boolean;
  reactions: ICommentReactions;
  replies: {
    total: number;
    data: IComment[];
  };
  status: string;
  story: {
    id: string;
    userId: number | null;
  };
  user: IStoryUser;
}

export interface IIclData {
  friends: number[] | null;
  acquaintance: boolean;
  communities?: string[] | null
}
